<div class="boxed">
  <div class="site-card">
    <div [innerHTML]="'legal.dataprotection.text' | i18next"></div>
  </div>
</div>
